import { fork, actionChannel, put, take, call } from 'redux-saga/effects';
import * as adminActions from './action';
import * as catActions from '../../Dashboard/action'
const settings = require('../../../settings');



/**
 * Saga watchers
 */
export function* watchGetSupergroupCategories() {
    let payload;
    const reqChannel = yield actionChannel(adminActions.GET_CATEGORIESFORSUPERGROUP_REQUEST)
    while (payload = yield take(reqChannel)) {

        yield fork(getCategoriesList, payload);
    }
}

export function* watchSetSupergroupCategories() {
    let payload;
    const reqChannel = yield actionChannel(adminActions.SET_CATEGORIESFORSUPERGROUP_REQUEST)
    while (payload = yield take(reqChannel)) {

        yield fork(setCategoriesList, payload);
    }
}

const getCategoriesFromjoobster = (payload) => {


    console.log('this is the category payload object: ', payload)
    return fetch(settings.api_base_path + settings.api_admin_path + "/supergroup/" + payload.sgid + "/category", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + payload.authToken
        },

    }).then((res) => res.json())
        .then((data) => data);


}




function* getCategoriesList(action) {
    try {
        const result = yield call(getCategoriesFromjoobster, action.payload)

        if (result.status == "ok") {
            yield put({ type: adminActions.GET_CATEGORIESFORSUPERGROUP_SUCCESS, payload: result.categories });
        } else {
            yield put({ type: adminActions.GET_CATEGORIESFORSUPERGROUP_ERROR, payload: {}, error: true });
        }

    } catch (error) {
        yield put({ type: adminActions.GET_CATEGORIESFORSUPERGROUP_ERROR, payload: error, error: true });
    }
}



const setCategoriesTojoobster = (payload) => {

    return fetch(settings.api_base_path + settings.api_admin_path + "/supergroup/" + payload.sgid + "/category", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + payload.authToken
        },
        body: JSON.stringify(payload.body),
    }).then((res) => res.json())
        .then((data) => data);


}




function* setCategoriesList(action) {
    try {
        const result = yield call(setCategoriesTojoobster, action.payload)

        if (result.status == "ok") {



            yield put({ type: adminActions.SET_CATEGORIESFORSUPERGROUP_SUCCESS, payload: result.categories });
            yield put({ type: catActions.UPDATE_CATEGORIES, payload: {categories: result.categories} });

        } else {
            yield put({ type: adminActions.SET_CATEGORIESFORSUPERGROUP_ERROR, payload: {}, error: true });
        }

    } catch (error) {
        yield put({ type: adminActions.SET_CATEGORIESFORSUPERGROUP_ERROR, payload: error, error: true });
    }
}


